var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 275,
    viewBox: "0 0 252 275",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23495_34599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.16 208.24C150.16 208.24 155.11 212.95 153.35 215.37C135.93 236.43 63.6 192.24 61.53 166.7L15.45 220.89",
    stroke: "#68B1E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.34 215.37L122.14 262.63",
    stroke: "#68B1E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.15 168.77L68.5001 118.5L79.5001 88.5C91.35 64.9999 110.12 121.93 92.0001 130C115.24 126.2 143 161.5 98.52 187.07",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.27 178.78C151.27 206.05 125.01 209.5 125.01 209.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.32 45.8601L165.91 173.41L127.22 163.39",
    stroke: "#68B1E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.32 73.15L128.49 1L210.3 17.92",
    stroke: "#68B1E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.06 17.5701L182.69 24.4701",
    stroke: "#68B1E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.1 146.46L147.92 149.91",
    stroke: "#68B1E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.5 87.4099C228.12 90.0699 222.94 61.2699 208.78 59.8899",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.63 88C216.78 89.38 221.96 118.18 194.35 115.52",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.07 115.69C210.22 117.07 215.4 145.87 183.8 141.31L175.86 169.88",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.36 82.37C72.62 81.03 68.6 80.3 64.4 80.3C44.85 80.3 29 96.15 29 115.7C29 135.25 44.85 151.1 64.4 151.1",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.26 137.42C243.506 137.42 250.19 130.736 250.19 122.49C250.19 114.244 243.506 107.56 235.26 107.56C227.014 107.56 220.33 114.244 220.33 122.49C220.33 130.736 227.014 137.42 235.26 137.42Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.2 160.82V204.41",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.99 182.61H185.4",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.47 39.3501V60.9401",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.26 50.1401H62.67",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.77 60.9199C179.76 29.2999 215.71 24.6499 215.71 24.6499L219.18 35.3799C219.18 35.3799 191.65 33.9499 156.86 72.5599C152.77 77.0999 145.49 76.5099 142.19 71.3699C137.43 63.9499 131.49 55.1299 129.24 53.6599L138.66 43.4399L147.95 55.4799",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.96 214.48C175.29 203.88 185.75 209.96 185.75 209.96",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.08 224.27C174.51 220.92 178.56 226.61 178.56 226.61",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.81 22.69C110.09 8.56999 98.27 5.98999 98.27 5.98999",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.37 29.15C99.15 21.66 92.33 23.12 92.33 23.12",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.34 229.25C175.13 240.83 187.94 253.18 185.34 262.23C181.05 277.17 136.37 277.45 85.56 262.85C34.75 248.25 -2.96 224.3 1.33 209.36C3.11 203.16 11.86 199.48 25.12 198.35",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.75 58.5299C182 61.7099 181.75 64.9699 180.95 68.2399C176.92 84.6299 160.36 94.6499 143.97 90.6099C127.58 86.5799 117.56 70.0199 121.6 53.6299C125.63 37.2399 142.19 27.2199 158.58 31.2599C162.68 32.2699 166.38 34.0599 169.56 36.4399",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23495_34599"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 251.19,
    height: 274.62,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCheck);
export default __webpack_public_path__ + "static/media/PhoneCheck.b1813320c1dbee5af5f95f2e16de1711.svg";
export { ForwardRef as ReactComponent };